<template>
  <div class="container lms-wrapper">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-b-20">
          <div class="row">
            <div v-for="(n, i) in welcomes" :class="`col-sm-${n.cols} tx-white tx-24 tx-semibold`" >
              <div @click="gotoW(n)" role="button" class="rounded-20 pd-30 d-flex lh-1" :style="`height: ${n.h}px; background: ${n.bg}; position: relative`">
                {{ n.title }}
                <div v-if="i<=1" :style="`right: 20px; bottom: 0px; position: absolute; width: 50%; height: 80%; background-image: url(${myResBaseUrl}${n.bgimg}); background-size: contain; background-repeat: no-repeat; background-position:  right`"></div>
                <div v-else :style="`left: 50%; transform: translate(-50%, 0%); bottom: 0px; position: absolute; width: 65%; height: 80%; background-image: url(${myResBaseUrl}${n.bgimg}); background-size: contain; background-repeat: no-repeat; background-position:  right`"></div>
                <div class="pos-absolute l-20 b-20 tx-white tx-14">Дэлгэрэнгүй</div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>

    <b-modal v-model="wlcomemdl" hide-footer hide-header centered 
      contentClass="bg-transparent rounded-lg-important" bodyClass="p-0">
      <template >
      <div @click.stop class="w-full max-w-xl rounded-lg shadow-lg pos-relative"
      style="font-family: 'SF Pro Rounded' !important;">
      <div class="pos-absolute r--10 t--10" @click="wlcomemdl = false" style="background: #00000040; border-radius: 50%; padding: 5px 10px; cursor: pointer;">
        <i class="fas fa-times tx-white tx-24"></i>
      </div>
        
        <div class="pos-absolute t-20 l-20">
          <img :src="`${myResBaseUrl}/apps/golomt/nptw.png`" style="max-width: 80px" />
        </div>
        
        <div class="flex items-center justify-center pt-6 mx-auto text-center text-white rounded-t-3xl"
        style="background: linear-gradient(to bottom, #357f99, #4d9fb9);">
          <div class="max-w-sm pt-6" >
            <div class="font-bold">САЙН БАЙНА УУ? </div>
            <div class="mb-2 text-2xl font-bold">{{$store.state.user.userInfo.fullName}} !</div>
            <div class="px-4 mb-6" v-html="greetingObj.title"></div>
            <div class="flex justify-center" style="height: 330px">
              <div :style="`width: 280px;
        background-image: url('${greetingObj.image}');
      background-size: cover; background-position: top`"></div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center p-6 mx-auto font-semibold text-center text-white rounded-b-3xl" style="background: #357f99; border-top: 5px solid #175b72">
          <div class="max-w-md py-2">
            <div class="leading-tight" v-html="greetingObj.description"></div>
          </div>
        </div>
      </div>
    </template>
    </b-modal>

    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, MessageBox } from "element-ui";

export default {
  components: {
    MessageBox,
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      wlcomemdl: false,
      myResBaseUrl: "https://res.gosmart.mn/",
      welcomes:[
        {id: 1, title: 'Голомт банкны тухай', img: '', color: '',  cols: 6, h: 280, bg: 'linear-gradient(135.15deg, #33B7FF 2.15%, #17A0E2 65.39%, #17A0E2 98.4%)',
          bgimg: 'apps/golomt/bg-buddy-1.png'
         },
        {id: 2, title: 'Голомтын соёл, гоёл', img: '', color: '', cols: 6, h: 280, bg: 'linear-gradient(135.15deg, #3AC37A 2.15%, #33BF75 65.39%, #55EB9B 98.4%)',
          bgimg: 'apps/golomt/bg-buddy-2.png'
         },
        { id: 3, title: 'Хөнгөлөлт, хангамж', img: '', color: '', cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #9C14F2 2.15%, #9627DD 65.39%, #B255EC 98.4%)',
          bgimg: 'apps/golomt/bg-buddy-3.png'
         },
        {id: 4, title: 'Хөтөлбөр', img: '', color: '', cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%);' ,
          bgimg: 'apps/golomt/bg-buddy-4.png'
        },
        { id: 5, title: 'Тоглох уу', img: '', color: '', cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #34BDBD 2.15%, #12A0A1 65.39%, #37BABC 98.4%);' ,
          bgimg: 'apps/golomt/bg-buddy-5.png'
        },
      ],
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      greetingObj:{
        title: `<b>"Ажиллахад хамгийн таатай газар"</b> болох Голомт банканд тавтай морил`,
        description: `Манай банкны ажилтнууд бүгд найрсаг бөгөөд шинэ ажилтан танд туслахад бэлэн байна. Хэрэв танд ямар нэгэн асуух зүйл, санал хүсэлт, тусламж хэрэгтэй бол нэгжийн удирдлага болон ХНУГ-т хандаарай.<br /><br />Голомтын аялал үргэлжилсээр .....`,
        image : `https://res.gosmart.mn/apps/golomt/bear.png?w=400`
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    let _greetingTitle = this.$store.state.app.groupSettings.filter(x => x.key == "buddy_greeting_title");
    if (_greetingTitle.length > 0) {
      this.greetingObj.title = _greetingTitle[0].value;
    }

    let _greetingDescr = this.$store.state.app.groupSettings.filter(x => x.key == "buddy_greeting_description");
    if (_greetingDescr.length > 0) {
      this.greetingObj.description = _greetingDescr[0].value;
    }

    let _greetingImg = this.$store.state.app.groupSettings.filter(x => x.key == "buddy_greeting_img");
    if (_greetingImg.length > 0) {
      this.greetingObj.image = _greetingImg[0].value;
    }

    if(this.$store.state.buddy.greeting){
      console.log('greeting 1');
      this.$nextTick(()=>{
        this.wlcomemdl = true;
      })
    }

    // this.$nextTick(()=>{
    //   this.wlcomemdl = true;
    //   // setTimeout(() => {
        
    //   // }, 1000);
    // })

    this.isExpired();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    isExpired(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Buddy/newbie/IsTrialExpired" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          if(res.data?.myTrial?.isExpired === true && res.data?.myTrial?.rate<=0){
            MessageBox.confirm("Туршилтын хугацаа дууссан ч BUDDY ажилтнаа үнэлээгүй байна. Үнэлгээ өгөх үү? "
            ,{
              confirmButtonText: "Тийм",
              cancelButtonText: "Үгүй",
              callback: action => {
                if (action == "cancel") {
                  //console.log('step 1');
                } else if (action == "confirm") {
                  this.$router.push({name: 'buddyChecklist' })
                }
              }
            })
          }
        }
      });
    },
    gotoW(n) {
      // console.log('n', n);
      switch(n.id){
        case 1: 
          window.open(getConfigValueByKey(this.$store.state.app.groupSettings, "groupWebsiteLink"), '_blank');
          // window.open('https://parliament.mn', '_blank');
          break;
        case 2: 
          this.$router.push({name: 'buddyCulture', params: { id: 0} })
          break;
        case 3: 
          this.$router.push({name: 'buddyVoucher', params: { id: 0} })
          break;
        case 4: 
          this.$router.push({name: 'buddyEvent', params: { id: 0} })
          break;
        case 5: 
          this.$router.push({name: 'buddyQuiz' })
          break;
        default: break;
      }
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
    },
    
  },
};
</script>
<style lang="scss">
.rounded-lg-important{
  border-radius: 30px !important;
  border: none;
  .modal-body{
    // border-radius: 50px !important;
    .rounded-lg{
      border-radius: 30px !important;
    }
  }
}
</style>